import { cx } from '@/lib/cx';
import { initials } from '@/lib/format';
import s from './Avatar.module.css';

export function Avatar({ name, size = 'md', className }: { name: string | null | undefined; size?: 'sm' | 'md' | 'lg'; className?: string }) {
  return (
    <span className={cx(s.avatar, s[size], className)} aria-hidden>
      {initials(name)}
    </span>
  );
}
